export enum LanguageCode {
  en = 'en',
  de = 'de',
  at = 'at'
}
